<template>
    <v-container>
        <v-timeline v-if="events" :dense="$vuetify.breakpoint.xsOnly">
            <v-timeline-item
                    v-for="(event,index) in events"
                    :key="index"
                    icon="mdi-star"
            >
                <span slot="opposite">{{event.day}}<br>{{event.hour}}</span>
                <v-card class="elevation-2">
                    <v-card-title class="headline"><span v-if="$vuetify.breakpoint.xsOnly">{{event.day}}:{{event.hour}}</span>{{event.title}}</v-card-title>
                    <v-card-text>{{event.content}}</v-card-text>
                </v-card>
            </v-timeline-item>
        </v-timeline>
        <v-alert type="info" v-else>Le déroulement n'est pas disponible pour le moment</v-alert>
    </v-container>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "Proceedings",
        data: () => {
            return {
                events: null,
            }
        },
        created() {
            axios.get('/data/proceedings.json').then(data => {
                this.events = data.data;
            }).catch(e => {
                console.error(e)
            })
        }
    }
</script>

<style scoped>

</style>